import { authService } from '@/services/auth.service';

export default {
  namespaced: true,
  state: {
    token: authService.getToken(),
    user: authService.getUser(),
    isLoading: false,
    tokenTimeRemaining: 0,
  },
  getters: {
    isAuthenticated: (state: any) => authService.isAuthenticated(),
    getUser: (state: any) => state.user,
    getToken: (state: any) => state.token,
    isLoading: (state: any) => state.isLoading,
    isTokenExpiringSoon: () => authService.isTokenExpiringSoon(),
    getTokenTimeRemaining: () => authService.getTokenTimeRemaining(),
  },
  mutations: {
    SET_LOADING(state: any, isLoading: boolean) {
      state.isLoading = isLoading;
    },
    SET_TOKEN(state: any, token: string | null) {
      state.token = token;
    },
    SET_USER(state: any, user: any) {
      state.user = user;
    },
    UPDATE_TOKEN_TIME(state: any) {
      state.tokenTimeRemaining = authService.getTokenTimeRemaining();
    },
    CLEAR_AUTH(state: any) {
      state.token = null;
      state.user = null;
      state.tokenTimeRemaining = 0;
    },
  },
  actions: {
    async login({ commit }: any, credentials: { username: string; password: string }) {
      commit('SET_LOADING', true);
      
      try {
        console.log('🏪 Store auth.login() called');
        const result = await authService.login(credentials);
        console.log('🏪 AuthService result:', result);
        
        if (result.success) {
          commit('SET_TOKEN', result.token);
          commit('SET_USER', result.user);
          commit('UPDATE_TOKEN_TIME');
          console.log('🏪 Auth state updated successfully');
          return result;
        } else {
          console.warn('🏪 Login failed:', result.message);
          throw new Error(result.message || 'Error al iniciar sesión');
        }
      } catch (error: any) {
        console.error('🏪 Store login error:', error);
        commit('CLEAR_AUTH');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    logout({ commit }: any) {
      commit('SET_LOADING', true);
      commit('CLEAR_AUTH');
      authService.logout();
      commit('SET_LOADING', false);
    },

    // Acción para verificar y actualizar el estado del token
    updateTokenStatus({ commit }: any) {
      const token = authService.getToken();
      const user = authService.getUser();
      
      if (authService.isAuthenticated()) {
        commit('SET_TOKEN', token);
        commit('SET_USER', user);
        commit('UPDATE_TOKEN_TIME');
      } else {
        commit('CLEAR_AUTH');
      }
    },

    // Acción para refrescar datos del usuario
    async refreshUserData({ commit }: any) {
      if (authService.isAuthenticated()) {
        const user = authService.getUser();
        commit('SET_USER', user);
        commit('UPDATE_TOKEN_TIME');
      }
    },
  },
};